import './MaintenanceBanner.css'; // ADDED

// Shown when maintenance.banner is set — displayed at top of site
export default function MaintenanceBanner({ siteConfig }) {
    if (!siteConfig?.siteBanner) return null;

    return (
        <div id="maintenance-banner-root">
            <p id="maintenance-banner-text">{siteConfig.siteBanner}</p>
            {siteConfig?.siteDescription && <p id="maintenance-banner-description">{siteConfig.siteDescription}</p>}
        </div>
    );
}
